export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoModal.vue?vue&type=template&id=c8a9a146&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoModal.vue?vue&type=template&id=c8a9a146&scoped=true&
// module id = 274
// module chunks = 0